import { useState } from 'react'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import {Button} from '@mui/material'
import EmojiEvents from '@mui/icons-material/EmojiEvents'
import { useRecordContext } from 'react-admin'
export const SeCodeCopyPodium = () => {
	const record = useRecordContext()
	const [copiedState, setCopiedState] = useState(false)
	const [subEventIdUrl] = useState('<iframe src="https://labs.competitor.com/clubpointsdetail/podium/subevent/' + record.SubEventId +'" importance="high" loading="lazy" frameborder="0" style="width: 100%; height: 667px;" height="100%" width="100%"></iframe>')
    	return record ? (
    		<div className="secode">
    			<input value={copiedState}
    				onChange={({ target: { value } }) => setCopiedState(true)} />
    			<CopyToClipboard text={subEventIdUrl}
    				onCopy={() => setCopiedState(true)}>
    				<Button startIcon={<EmojiEvents />} variant="outlined" color="primary" size="small">Podium Awards</Button>
    			</CopyToClipboard>
    			{copiedState ? <span style={{ color: 'red', whiteSpace: 'pre', display: 'block', width: '100%', textAlign: 'center' }}>SECode Copied</span> : null}
    		</div>
    	) : null
}
export default SeCodeCopyPodium